import React, { useState } from "react";
import puzzle from "@images/puzzle.svg";
import arrow_drop_down from "@images/arrow_drop_down.svg";
import standartPlus from "@images/standart_plus.svg";
import Description from "./Description";

const features_free = [
  I18n.t("plans.standardPlus.bullet1"),
  I18n.t("plans.standardPlus.bullet2"),
  I18n.t("plans.standardPlus.bullet3"),
];

const StandardPlus = ({ activeTab, rateData = [] }) => {
  const [showDetails, setShowDetails] = useState(false);

  const tariffs = rateData.filter((t) => t.key === "standard_plus");

  let activeRate = null;
  for (const tariff of tariffs) {
    activeRate = tariff.rate_data.find((r) => r.key === activeTab);
    if (activeRate) break;
  }

  if (!activeRate) {
    console.error("Active rate not found for tab:", activeTab);
    return null;
  }

  const handleClick = () => {
    setShowDetails(!showDetails);
  };

  return (
    <div className="standart-plus-block" onClick={handleClick}>
      <div className="price-header">
        <img
          className="price-header__img"
          width="48"
          height="48"
          src={puzzle}
          alt="puzzle"
        />
        <div className="price-header__txt pro">
          <img
            className="pro__name"
            style={{ width: "127px" }}
            src={standartPlus}
            width="127"
            height="30"
            alt="standartPlus"
          />
          <p className="pro__price">
            {activeRate.price + " ₽ / " + I18n.t("plans.per_" + activeTab)}
          </p>
          <p className="pro__details">{activeRate.details}</p>
        </div>
        <img
          className="price-header__arrow_drop_down"
          width="9"
          height="7"
          src={arrow_drop_down}
          alt="arrow_drop_down"
        />
      </div>

      <Description
        showDetails={showDetails}
        activeTab={activeTab}
        features={features_free}
        paidStandartPlus={true}
      />
    </div>
  );
};

export default StandardPlus;
